import { render, staticRenderFns } from "./ListaCatalogos.vue?vue&type=template&id=7f3672c0&"
import script from "./ListaCatalogos.vue?vue&type=script&lang=js&"
export * from "./ListaCatalogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports